export const THEME_STORAGE_KEY = "vl-fleet-theme-preference";

const THEME_PREFERENCES = new Set(["auto", "light", "dark"]);
const THEME_ICONS = Object.freeze({
  auto: "system",
  light: "sun",
  dark: "moon",
});

export function normalizeThemePreference(value) {
  const preference = String(value || "")
    .trim()
    .toLowerCase();
  return THEME_PREFERENCES.has(preference) ? preference : "";
}

export function resolveTheme(preference, systemTheme = "light") {
  const normalized = normalizeThemePreference(preference) || "auto";
  if (normalized !== "auto") return normalized;
  return systemTheme === "dark" ? "dark" : "light";
}

export function getThemeIconName(preference) {
  const normalized = normalizeThemePreference(preference) || "auto";
  return THEME_ICONS[normalized];
}

export function readStoredTheme(storage) {
  try {
    return normalizeThemePreference(storage?.getItem(THEME_STORAGE_KEY));
  } catch (error) {
    return "";
  }
}

export function writeStoredTheme(storage, preference) {
  const normalized = normalizeThemePreference(preference) || "auto";
  try {
    storage?.setItem(THEME_STORAGE_KEY, normalized);
  } catch (error) {
    return normalized;
  }
  return normalized;
}
